import type { StoreActionApi } from 'react-sweet-state';
import { createStore, createHook } from 'react-sweet-state';

interface ContentTreeSelectionState {
	isMultiSelectActive: boolean;
	selectedContentIds: string[];
}

const initialState: ContentTreeSelectionState = {
	isMultiSelectActive: false,
	selectedContentIds: [],
};

const actions = {
	toggleMultiSelect:
		(active?: boolean) =>
		({ setState, getState }: StoreActionApi<ContentTreeSelectionState>) => {
			const { isMultiSelectActive, selectedContentIds } = getState();
			const nextActive = typeof active === 'boolean' ? active : !isMultiSelectActive;
			setState({
				isMultiSelectActive: nextActive,
				// Clear selection when disabling multi-select
				selectedContentIds: nextActive ? selectedContentIds : [],
			});
		},
	selectContent:
		(contentId: string) =>
		({ setState, getState }: StoreActionApi<ContentTreeSelectionState>) => {
			const { selectedContentIds, isMultiSelectActive } = getState();

			if (!isMultiSelectActive) {
				setState({ selectedContentIds: [contentId] });
				return;
			}

			if (!selectedContentIds.includes(contentId)) {
				setState({
					selectedContentIds: [...selectedContentIds, contentId],
				});
			}
		},

	unselectContent:
		(contentId: string) =>
		({ setState, getState }: StoreActionApi<ContentTreeSelectionState>) => {
			const { selectedContentIds } = getState();
			setState({
				selectedContentIds: selectedContentIds.filter((id) => id !== contentId),
			});
		},

	clearSelection:
		() =>
		({ setState }: StoreActionApi<ContentTreeSelectionState>) => {
			setState({
				selectedContentIds: [],
			});
		},
};

const Store = createStore<ContentTreeSelectionState, typeof actions>({
	initialState,
	actions,
	name: 'contentTreeSelection',
});

export const useContentTreeSelection = createHook(Store);
